module.exports = __webpack_public_path__ + "img/章節目錄active.403711a7.svg";